
    const data = {"name":"src/core/icons/loading","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M12 4V2A10 10 0 0 0 2 12h2a8 8 0 0 1 8-8Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            